import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/development', label: 'Development' },
  { path: '/portfolio', label: 'Portfolio' },
  { path: '/contact', label: 'Contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <>
      <nav className={`nav-wrap ${scrolled ? 'scrolled' : ''}`}>
        <div className="container d-flex align-items-center justify-content-between">
          <Link to="/" className="nav-logo">Cegon Soft Tech</Link>
          <div className="d-none d-lg-flex align-items-center gap-5">
            {navLinks.map(l => (
              <Link key={l.path} to={l.path}
                className={`nav-link ${location.pathname === l.path ? 'active' : ''}`}>
                {l.label}
              </Link>
            ))}
          </div>
          <div className="d-none d-lg-block">
            <Link to="/contact" className="btn-warm">
              <span>Get in Touch</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.2"/>
              </svg>
            </Link>
          </div>
          <button onClick={() => setOpen(!open)} className="d-lg-none"
            style={{ background:'none', border:'none', color:'var(--cream)', cursor:'pointer', fontFamily:'var(--font-body)', fontSize:'0.72rem', letterSpacing:'0.2em', textTransform:'uppercase' }}>
            {open ? 'CLOSE' : 'MENU'}
          </button>
        </div>
      </nav>

      {open && (
        <div style={{ position:'fixed', inset:0, background:'var(--bg2)', zIndex:999, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:36 }}>
          {navLinks.map(l => (
            <Link key={l.path} to={l.path}
              style={{ fontFamily:'var(--font-disp)', fontSize:'2.4rem', color:'var(--cream2)' }}>
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export default Navbar;
